'use strict';

var assertion = require('./assertion.js');

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => { };
function runIfFn(valueOrFn, ...args) {
    return assertion.isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function once(fn) {
    // eslint-disable-next-line @typescript-eslint/init-declarations
    let result;
    return function func(...args) {
        if (fn) {
            result = fn.apply(this, args);
            // eslint-disable-next-line no-param-reassign
            fn = null;
        }
        return result;
    };
}
const warn = once((options) => () => {
    const { condition, message } = options;
    if (condition && assertion.__DEV__) {
        console.warn(message);
    }
});
const error = once((options) => () => {
    const { condition, message } = options;
    if (condition && assertion.__DEV__) {
        console.error(message);
    }
});
function safeInvoke(fn, ...args) {
    return fn?.(...args);
}
function debounce(func, wait = 300, immediate = false) {
    // eslint-disable-next-line @typescript-eslint/init-declarations
    let timeout;
    return function executedFunction(...args) {
        // eslint-disable-next-line func-style
        const later = function () {
            timeout = null;
            if (!immediate)
                func.apply(this, args);
        };
        // @ts-ignore
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (immediate)
            func.apply(this, args);
    };
}
function throttle(func, wait = 300) {
    let isThrottled = false;
    let savedArgs = null;
    let savedThis = null;
    function wrapper(...args) {
        if (isThrottled) {
            savedArgs = args;
            // нужно сохранять в переменную, чтобы при вызове функции иметь последние данные
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            savedThis = this;
            return;
        }
        func.apply(this, args);
        isThrottled = true;
        setTimeout(() => {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(savedThis, savedArgs);
                savedArgs = null;
                savedThis = null;
            }
        }, wait);
    }
    return wrapper;
}

exports.debounce = debounce;
exports.error = error;
exports.noop = noop;
exports.once = once;
exports.runIfFn = runIfFn;
exports.safeInvoke = safeInvoke;
exports.throttle = throttle;
exports.warn = warn;
//# sourceMappingURL=function.js.map
